<template>
  <!-- 账号密码截图 -->
  <div>
    <div class="page_win msgProtect">
      <div class="headerBox">
        <div class="head"><span>账号注销</span></div>
        <div class="closeBtn" @click="cancelBtn"><img :src="closeImg" /></div>
      </div>
      <div class="msg">
        <span>为保障您的账号安全，注销账号需点击”客服“联系人工客服处理，账号核查和注销将会在15个工作日内完成！</span>
      </div>
      <div class="bot_btn"  @click="cancelBtn"><span>确定</span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["", ""],
  inject: ["reload"],
  data() {
    return {
      closeImg: require("../../assets/img/new2/close.png"), // 关闭
    };
  },
  creater() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    // 关闭当前窗口
    cancelBtn: function () {
      this.$store.dispatch("IsLogoutAccountFun", false);
      this.$store.dispatch("IsUserInfoMaskFun", true);
    },
  },
};
</script>
<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.headerBox {
  @include flex_box(row, space-between, stretch);
  margin-bottom: 0.1rem;
  height: 0.5rem;
  position: relative;
}
.head {
  flex: 1;
  color: #ff913a;
  font-size: 16px;
  font-weight: bold;
  @include flex_box(row, center, center);

}
.closeBtn {
  position: absolute;
  right: 0;
  top: 0;
  @include flex_box(row, flex-end, center);
  width: 0.5rem;
  height: 0.5rem;
  img {
    width: 0.3rem;
    height: auto;
  }
}
.msg {
  color: #838383;
  font-size: 12px;
  padding: 0.3rem .3rem  ;
  span {
    line-height: 0.36rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/view8/logoutAccount.vue